import { IDeleteAssistenciaPesquisaSatisfacaoUseCase } from "../../../presentation/useCases/delete/delete_assistencia_pesquisa_satisfacao_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteAssistenciaPesquisaSatisfacaoUseCase
 */

export class DeleteAssistenciaPesquisaSatisfacaoUseCase implements IDeleteAssistenciaPesquisaSatisfacaoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deleteAssistenciaPesquisaSatisfacao(
    idAssistenciaTecnica: number,
    idPesquisaSatisfacaoCliente: number,
  ): Promise<void> {
    await this.repository.deleteAssistenciaPesquisaSatisfacao(
      idAssistenciaTecnica,
      idPesquisaSatisfacaoCliente,
    );
  }
}
